import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { appMount } from './store/actions/app-actions';
import { routesList } from 'src/navigation';
import NoMatch from 'src/screens/NoMatch';
import { ConnectedRouter } from 'connected-react-router';
import history from './navigation/history';
import { ToastContainer } from 'react-toastify';
import { store } from 'src/store/configure-store';
import Main from 'src/components/layout/Main';
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';

moment.locale('en');
momentLocalizer();
function App(): React.ReactElement {
    useEffect(() => {
        store.dispatch(appMount());
    }, []);

    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Main>
                    <Switch>
                        {routesList.map((route: any, i) => {
                            return React.cloneElement(route, { key: i });
                        })}
                        <Route component={NoMatch} />
                    </Switch>
                </Main>
            </ConnectedRouter>
            <ToastContainer />
        </Provider>
    );
}

export default App;
